<template>
  <div class="donation-content-container pic-full">
    <p class="title">{{ homeLang.donation.join }}</p>
    <div class="address-container" v-if="isTP">
      <p class="label-p"><label>{{ homeLang.donation.yourAddress }}</label></p>
      <div class="address">{{ currentAddressShow }}</div>
    </div>
    <div class="donate-chain-container" v-else>
      <p class="label-p"><label>{{ homeLang.donation.donateChain }}</label></p>
      <div class="donate-chain" @click.stop="slideShow=!slideShow">
        <img class="chain-container"
             :src="item.logo"
             v-for="item in chainList"
             v-if="!chosenChain.title&&!slideShow || chosenChain.title===item.title">
        <span class="chain-title">{{ chosenChain.title }}</span>
        <div class="right-container pic-full" v-show="!slideShow"></div>
      </div>
      <div class="donate-chain-slide" v-show="slideShow">
        <ul>
          <li v-for="item in chainList" @click.stop="chooseChain(item)">
            <img :src="item.logo">
            <span :class="{'chosen-chain':item.title===chosenChain.title}">{{ item.title }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="address-container">
      <p class="label-p"><label>{{ homeLang.donation.donateAddress }}</label></p>
      <div class="address">{{ donateAddressShow }}</div>
    </div>
    <div class="address-container">
      <p class="label-p"><label>{{ homeLang.donation.donateCount }}</label></p>
      <input class="address donate-count" @input="alterDonateCount" v-model="donateCount">
    </div>
<!--    <div class="tip-container">-->
<!--      <p>{{ homeLang.donation.donateTip.title }}</p>-->
<!--      <p>{{ homeLang.donation.donateTip.desc }}</p>-->
<!--    </div>-->
    <div class="disabled-button-container flex-center"
         v-if="isTP&&!supportedWallet.includes(currentWallet)">
      {{ homeLang.donation.cantDonate }}
    </div>
    <div class="disabled-button-container flex-center"
         v-else-if="!isTP&&wrongNetwork&&currentWallet!=='eos'&&currentWallet!=='tron'">
      {{ homeLang.donation.pleaseSwitch1 + currentWallet.toUpperCase() + homeLang.donation.pleaseSwitch2 }}
    </div>
    <div class="disabled-button-container flex-center" v-else-if="overCount">
      {{ homeLang.donation.overCount }}
    </div>
    <div class="button-container pic-full flex-center"
         :class="mouseDown ? 'down' : 'normal'"
         @mousedown="mouseDown=true"
         @mouseup="mouseDown=false"
         @touchstart="mouseDown=true"
         @touchend="mouseDown=false"
         @click="donate"
         v-else>
      <span>{{ homeLang.donation.confirmDonate }}</span>
    </div>
  </div>
</template>

<script>
// ETH:0x1F0D22035fB7Fe47d0d852c243C43C626B58B436
// BSC:0x1F0D22035fB7Fe47d0d852c243C43C626B58B436
// HECO:0x1F0D22035fB7Fe47d0d852c243C43C626B58B436
// OEC:0x1F0D22035fB7Fe47d0d852c243C43C626B58B436
// TRON:TRPSDPVWkGahnA5iDR5vkjNifWhbaHmaH4
// EOS:tptdonation1
const tp = require('tp-js-sdk')
import clipboard from "@/directive/clipboard";
import ScatterJS from "@scatterjs/core"
import ScatterEOS from "@scatterjs/eosjs2"
import {Api, JsonRpc} from "eosjs"

ScatterJS.plugins(new ScatterEOS());

export default {
  name: "donationContent",
  props: {
    homeLang: {
      type: Object
    }
  },
  data() {
    return {
      mouseDown: false,
      chosenChain: {
        title: undefined,
        logo: undefined
      },
      slideShow: false,
      chainList: [{
        title: 'Ethereum',
        logo: require('../../assets/pc/donation/eth.png'),
        address: '0x1F0D22035fB7Fe47d0d852c243C43C626B58B436',
        wallet: 'eth',
        tptContract: '0x4161725D019690a3E0de50f6bE67b07a86A9fAe1',
      },{
        title: 'Binance Smart Chain',
        logo: require('../../assets/pc/donation/bsc.png'),
        address: '0x1F0D22035fB7Fe47d0d852c243C43C626B58B436',
        wallet: 'bsc',
        tptContract: '0xECa41281c24451168a37211F0bc2b8645AF45092',
      },{
        title: 'HECO Chain',
        logo: require('../../assets/pc/donation/heco.png'),
        address: '0x1F0D22035fB7Fe47d0d852c243C43C626B58B436',
        wallet: 'heco',
        tptContract: '0x9ef1918a9bee17054b35108bd3e2665e2af1bb1b',
      },{
        title: 'OKEx Chain',
        logo: require('../../assets/pc/donation/okex.png'),
        address: '0x1F0D22035fB7Fe47d0d852c243C43C626B58B436',
        wallet: 'oec',
        tptContract: '0x2ceC1C3f71Db54C99D6df687d8AC968cCe80CC85',
      },
      // {
      //   title: 'Hoo Smart Chain',
      //   logo: require('../../assets/pc/donation/hoo.png'),
      //   address: '0x5f80670522f999e56310E0f3f8BBb5b0348B1EC8',
      //   wallet: 'hsc',
      //   tptContract: '0x263e10bE808bafaD9bd62a0998a36d4e6B9fcb19',
      // },
      {
        title: 'Tron',
        logo: require('../../assets/pc/donation/tron.png'),
        address: 'TRPSDPVWkGahnA5iDR5vkjNifWhbaHmaH4',
        wallet: 'tron',
        tptContract: 'TYJ4Wn8juQL6PiY9o3c1PCN4Wh4wdXJL7S',
      },{
        title: 'EOS',
        logo: require('../../assets/pc/donation/eos.png'),
        address: 'tptdonation1',
        wallet: 'eos',
        tptContract: 'eosiotptoken'
      },],
      supportedWallet: ['eth','bsc','heco','oec','hsc','tron','eos'],
      isTP: false,
      currentWallet: '',
      currentAddress: '',
      donateAddress: '',
      donateCount: '0',
      abi: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"}],
      web3: undefined,
      overCount: true,
      tronAbi: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}],
      wrongNetwork: false
    }
  },
  computed: {
    currentAddressShow() {
      let len = this.currentAddress.length
      return len > 30 ? this.currentAddress.substring(0,20)+'...'+this.currentAddress.substring(len-4,len)
                : len ? this.currentAddress : ''
    },
    donateAddressShow() {
      let len = this.donateAddress.length
      return len > 30 ? this.donateAddress.substring(0,20)+'...'+this.donateAddress.substring(len-4,len)
                : len ? this.donateAddress : ''
    },
    isPC() {
      const width = document.documentElement.clientWidth
      return width >= 767
    }
  },
  async created() {
    if (navigator.userAgent.indexOf('TokenPocket') > -1) {
      await this.init()
    }
  },
  mounted() {
    window.addEventListener('click', () => {
      this.slideShow = false
    })
  },
  directives: {
    clipboard
  },
  watch: {
    donateCount() {
      this.setDonateStatus()
    }
  },
  methods: {
    chooseChain(item) {
      this.chosenChain.title = item.title
      this.chosenChain.logo = item.logo
      this.donateAddress = item.address
      this.slideShow = false
      this.currentWallet = item.wallet
      this.init()
    },
    clipboardSuccess() {
      this.$toast({
        text: this.homeLang.donation.copied
      })
    },
    alterDonateCount() {      // 只能输入数字
      let donateCount = this.donateCount
      if (donateCount) {
        this.donateCount = donateCount.replace(/[^\d.]/g, '')
        if(this.donateCount.charAt(this.donateCount.length - 1) === '.'&&
            this.donateCount.indexOf('.')!==this.donateCount.length - 1||this.donateCount.indexOf('.')===0){
          this.donateCount = this.donateCount.substring(0,this.donateCount.length - 1)
        }
      }
      if(donateCount.indexOf('.')!==-1 && donateCount.length > donateCount.indexOf('.')+4){
        this.donateCount = donateCount.substring(0,donateCount.indexOf('.') + 5)
      }
    },
    async init() {
      if (navigator.userAgent.indexOf('TokenPocket') > -1) {
        this.isTP = true
        try {
          const res = await tp.getCurrentWallet()
          this.currentWallet = res.data.blockchain
          console.log(this.currentWallet)
          this.currentAddress = this.currentWallet === 'eos' ? res.data.name : res.data.address
          if (this.supportedWallet.includes(this.currentWallet)) {
            this.donateAddress = this.chainList.find(item => item.wallet === this.currentWallet).address
            if (['eth','bsc','heco','oec','hsc'].includes(this.currentWallet)) {
              this.initEth()
            } else if ('tron' === this.currentWallet) {
              this.initTron()
            } else if ('eos' === this.currentWallet) {
              this.initEOS()
            }
          }
        } catch (err) {
          console.error(err)
        }
      } else {
        if (['eth','bsc','heco','oec','hsc'].includes(this.currentWallet)) {
          await this.initEthPC()
        } else if ('tron' === this.currentWallet) {
          await this.initTronPC()
        } else if ('eos' === this.currentWallet) {
          await this.initEOSPC()
        }
      }
    },
    initEth() {
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      if (!chainInfo.contract) {
        let web3
        if (this.web3) {
          web3 = this.web3
        } else {
          let Web3 = require('web3')
          this.web3 = web3 = new Web3(window.ethereum)
        }
        let contract = new web3.eth.Contract(this.abi, chainInfo.tptContract)
        this.$set(chainInfo, 'contract', contract)
        this.getETHBalance(chainInfo)
      }
    },
    async initEthPC() {
      const _this = this
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      if (!chainInfo.contract) {
        let web3
        if (this.web3) {
          web3 = this.web3
        } else {
          let Web3 = require('web3')
          this.web3 = web3 = new Web3(window.ethereum)
        }
        await setEthInfo(chainInfo, web3)
        window.ethereum.on('accountsChanged', () => {
          setEthInfo(chainInfo, web3)
        })
        window.ethereum.on("chainChanged", () => {
          const nowChainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
          setEthInfo(nowChainInfo, web3)
        });
      } else {
        await setEthInfo(chainInfo, this.web3)
      }
      async function setEthInfo(chainInfo, web3) {
        const account = await connectEth()
        _this.currentAddress = account[0]
        let contract = new web3.eth.Contract(_this.abi, chainInfo.tptContract)
        _this.$set(chainInfo, 'contract', contract)
        _this.getETHBalance(chainInfo)
      }
      function connectEth(){
        return new Promise(resolve => {
          if (!window.ethereum) {
            _this.$toast({
              text: _this.homeLang.donation.downloadTP,
              isPC: _this.isPC,
            })
          } else {
            window.ethereum.request({
              method: 'eth_requestAccounts',
            }).then(res=>{
              resolve(res)
            })
          }
        })
      }
    },
    initTron() {
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      if (!chainInfo.contract) {
        const contract = window.tronWeb.contract(this.tronAbi, chainInfo.tptContract)
        this.$set(chainInfo, 'contract', contract)
        this.getTronBalance(chainInfo)
      }
    },
    async initTronPC() {
      const _this = this
      const chainInfo = this.chainList.find(item => item.wallet === this.currentWallet)
      if (window.tronWeb) {
        if (!chainInfo.contract) {
          const contract = window.tronWeb.contract(this.tronAbi, chainInfo.tptContract)
          this.$set(chainInfo, 'contract', contract)
          setTronInfo(chainInfo)
          window.addEventListener('message', e => {
            if (e.data.message && e.data.message.action === 'accountsChanged') {
              setTimeout(() => {
                setTronInfo(chainInfo)
              }, 1000)
            }
          })
        } else {
          setTronInfo(chainInfo)
        }
      } else {
        this.$toast({
          text: this.homeLang.donation.downloadTP,
          isPC: this.isPC,
        })
      }
      function setTronInfo(chainInfo) {
        _this.currentAddress = window.tronWeb.defaultAddress.base58
        if (!_this.currentAddress) {
          _this.$toast({
            text: _this.homeLang.donation.connectTronLink,
            isPC: _this.isPC,
          })
          return false
        }
        _this.getTronBalance(chainInfo)
      }
    },
    initEOS() {
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      if (!chainInfo.rpc) {
        const network = ScatterJS.Network.fromJson({
          blockchain: "eos",
          chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
          host: "eospush.tokenpocket.pro",
          port: 443,
          protocol: "https"
        });
        const rpc = new JsonRpc(network.fullhost());
        let scatter, api
        ScatterJS.scatter.connect("scatter-demo", { network }).then(connected => {
          if (!connected) return false
          scatter = ScatterJS.scatter
          scatter.login().then(id => {
            const account = scatter.identity.accounts.find(
                x => x.blockchain === "eos"
            )
            api = scatter.eos(network, Api, { rpc })
            this.$set(chainInfo, 'rpc', rpc)
            this.$set(chainInfo, 'api', api)
            this.$set(chainInfo, 'account', account)
            this.getEOSBalance(chainInfo)
          }).catch(error => {
            console.error(error)
          });
        })
      }
    },
    initEOSPC() {
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      if (!chainInfo.rpc) {
        const network = ScatterJS.Network.fromJson({
          blockchain: "eos",
          chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
          host: "eospush.tokenpocket.pro",
          port: 443,
          protocol: "https"
        });
        const rpc = new JsonRpc(network.fullhost());
        let scatter, api
        ScatterJS.scatter.connect("scatter-demo", { network }).then(connected => {
          if (!connected) return false
          scatter = ScatterJS.scatter
          scatter.login().then(id => {
            const account = scatter.identity.accounts.find(
              x => x.blockchain === "eos"
            )
            this.currentAddress = account.name
            api = scatter.eos(network, Api, { rpc })
            this.$set(chainInfo, 'rpc', rpc)
            this.$set(chainInfo, 'api', api)
            this.$set(chainInfo, 'account', account)
            this.getEOSBalance(chainInfo)
          }).catch(error => {
            console.error(error)
          });
        })
      } else {
        this.currentAddress = chainInfo.account.name
        this.getEOSBalance(chainInfo)
      }
    },
    parseCount(val) {
      if(val.indexOf('.')!==-1){
        let n = val.length - val.indexOf('.') - 1
        return Math.round(parseFloat(val) * Math.pow(10, n)) * Math.pow(10, 4-n)
      } else {
        return Math.round(parseFloat(val) * Math.pow(10,4))
      }
    },
    setDonateStatus() {
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      // if (!chainInfo.balance) return false
      const availableBalance = chainInfo.balance
      let donateCount = this.currentWallet === 'eos' ?
          parseFloat(this.donateCount) : this.parseCount(this.donateCount)
      this.overCount = donateCount > availableBalance
    },
    donate() {
      if(!parseFloat(this.donateCount)) {
        this.$toast({
          text: this.homeLang.donation.noZero,
          isPC: this.isPC
        })
        return false
      }
      const chainInfo = this.chainList.find(item=>item.wallet===this.currentWallet)
      const contract = chainInfo.contract
      const donateCount = this.currentWallet === 'eos' ?
          parseFloat(this.donateCount) : this.parseCount(this.donateCount)
      if (['eth','bsc','heco','oec','hsc'].includes(this.currentWallet)) {
        contract.methods.transfer(chainInfo.address, donateCount).send({from: this.currentAddress})
            .on('transactionHash',hash=>{
          this.$toast({
            text: this.homeLang.donation.waitBlockConfirm,
            isPC: this.isPC
          })
        }).on('receipt', receipt=>{
          this.$toast({
            text: this.homeLang.donation.donateSuccess,
            isPC: this.isPC
          })
          this.getETHBalance(chainInfo)
        }).on('error',err=>{
          console.error(err)
          if (err && err.code===-32000) {
            this.$toast({
              text: this.homeLang.donation.donateFail,
              isPC: this.isPC
            })
          } else {
            this.$toast({
              text: this.homeLang.donation.donateFail,
              isPC: this.isPC
            })
          }
        })
      } else if ('tron' === this.currentWallet) {
        contract.transfer(chainInfo.address, donateCount).send({
          feeLimit: 100000000,
          callValue: 0
        }).then(res=>{
          this.$toast({
            text: this.homeLang.donation.donateSuccess,
            isPC: this.isPC
          })
          this.getTronBalance(chainInfo)
        }).catch(err=>{
          console.log(err)
          this.$toast({
            text: this.homeLang.donation.donateFail,
            isPC: this.isPC
          })
        })
      } else if ('eos' === this.currentWallet) {
        const api = chainInfo.api, account = chainInfo.account
        api.transact({
          actions: [
            {
              account: chainInfo.tptContract,
              name: "transfer",
              authorization: [
                {
                  actor: account.name,
                  permission: account.authority
                }
              ],
              data: {
                from: account.name,
                to: chainInfo.address,
                quantity: donateCount.toFixed(4).toString() + ' TPT',
                memo: ""
              }
            }
          ]
        }, {
          blocksBehind: 3,
          expireSeconds: 30
        }).then(res => {
          this.$toast({
            text: this.homeLang.donation.donateSuccess,
            isPC: this.isPC
          })
          this.getEOSBalance(chainInfo)
        }).catch(err => {
          console.error(err)
          this.$toast({
            text: this.homeLang.donation.donateFail,
            isPC: this.isPC
          })
        });
      }
    },
    getEOSBalance(chainInfo) {
      chainInfo.rpc.get_table_rows({
        json: true,               // Get the response as json
        code: chainInfo.tptContract,      // Contract that we target
        scope: this.currentAddress,         // Account that owns the data
        table: 'accounts',        // Table name
        limit: 1,                // Maximum number of rows that we want to get
        reverse: false,           // Optional: Get reversed data
        show_payer: false
      }).then(res => {
        if (res.rows && res.rows.length && res.rows[0].balance) {
          this.$set(chainInfo, 'balance', parseFloat(res.rows[0].balance))
          console.log(chainInfo.balance)
          this.setDonateStatus()
        }
      })
    },
    getTronBalance(chainInfo) {
      chainInfo.contract.balanceOf(this.currentAddress).call().then(res=>{
        this.$set(chainInfo, 'balance', parseFloat(res))
        console.log(chainInfo.balance)
        this.setDonateStatus()
      })
    },
    getETHBalance(chainInfo) {
      console.log(this.currentAddress)
      chainInfo.contract.methods.balanceOf(this.currentAddress).call().then(res=>{
        this.$set(chainInfo, 'balance', parseFloat(res))
        this.wrongNetwork = false
        this.setDonateStatus()
        console.log(res)
      }).catch(err=>{
        console.error(err)
        this.wrongNetwork = true
      })
    }
  }
}
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .donation-content-container {
    position: absolute;
    left: 5rem;
    top: 0.83rem;
    width: 5.32rem;
    height: 8.34rem;
    background-image: url("../../assets/pc/donation/bg.png");
    display: flex;
    align-items: center;
    flex-direction: column;

    &::after {
      content: '';
      width: 5.3rem;
      height: 8.13rem;
      position: absolute;
      background-image: url("../../assets/pc/donation/bgShadow.png");
      background-size: 100%;
      background-repeat: no-repeat;
      z-index: -79;
      left: 0.19rem;
      top: 0.41rem;
    }

    .title {
      font-size: 0.26rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      color: #333333;
      line-height: 0.37rem;
      margin-top: 1.13rem;
      width: 100%;
      text-align: center;
    }
    .label-p {
      font-size: 0.18rem;
      line-height: 0.25rem;
      label {
        font-family: PingFangSC, PingFangSC-Regular;
        color: #333333;
      }
    }
    .address-container {
      margin-top: 0.25rem;
      width: 3.4rem;

      .address {
        box-sizing: content-box;
        margin-left: -0.02rem;
        width: 3.1rem;
        height: 0.44rem;
        background: rgba(255,255,255,0.20);
        border: 0.02rem solid #ffffff;
        border-radius: 0.04rem;
        margin-top: 0.08rem;
        padding: 0 0.15rem;
        display: flex;
        align-items: center;
        font-size: 0.18rem;
        font-family: PingFangSC, PingFangSC-Regular;
      }
      .donate-count {
        display: block;
        color: #333333;
        padding: 0 0.15rem;
        font-size: 0.18rem;
      }
    }
    .donate-chain-container {
      margin-top: 0.25rem;
      width: 3.4rem;

      .donate-chain {
        box-sizing: content-box;
        margin-left: -0.02rem;
        width: 3.4rem;
        height: 0.44rem;
        background: rgba(255,255,255,0.20);
        border: 0.02rem solid #ffffff;
        border-radius: 0.04rem;
        margin-top: 0.08rem;
        display: flex;
        align-items: center;
        cursor: pointer;

        .chain-container {
          width: 0.28rem;
          height: 0.28rem;
          margin-left: -0.08rem;

          &:first-child {
            margin-left: 0.16rem;
          }
        }
        .chain-title {
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #3a3b3d;
          margin-left: 0.08rem;
        }

        .right-container {
          width: 0.08rem;
          height: 0.14rem;
          background-image: url("../../assets/pc/donation/right.png");
          margin-right: 0.16rem;
          margin-left: auto;
        }
      }
      .donate-chain-slide {
        position: absolute;
        width: 3.4rem;
        margin-top: 0.04rem;
        cursor: pointer;

        ul {
          background-color: white;
          border-radius: 0.04rem;
          li {
            height: 0.4rem;
            width: 3.08rem;
            margin: 0 auto;
            border-bottom: #e8eaec 0.01rem solid;
            display: flex;
            align-items: center;

            &:hover span {
              color: #2761e7;
            }
            img {
              height: 0.28rem;
              width: 0.28rem;
            }
            span {
              font-size: 0.14rem;
              margin-left: 0.08rem;
              font-family: PingFangSC, PingFangSC-Regular;
              color: #3a3b3d;

              &.chosen-chain {
                color: #2761e7;
              }
            }
          }
        }
      }
    }
    .tip-container {
      margin-top: 0.24rem;
      p {
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #ed4c56;
        line-height: 0.22rem;
        width: 3.4rem;
      }
    }
    .button-container {
      margin-top: 0.37rem;
      width: 3.6rem;
      height: 0.83rem;
      font-size: 0.18rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #ffffff;
      cursor: pointer;

      &.normal {
        background-image: url("../../assets/pc/button.png");
      }
      &.down {
        background-image: url("../../assets/pc/button_down.png");
        transform: translate(0.03rem, 0.03rem);
      }
    }
    .disabled-button-container {
      margin-top: 0.37rem;
      width: 3.6rem;
      height: 0.7rem;
      border-radius: 0.42rem;
      font-size: 0.18rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #ffffff;
      background-color: #93bffe;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 767px) {
  .donation-content-container {
    margin-top: 0.3rem;
    height: 12.01rem;
    background-image: url("../../assets/pc/donation/bg.png");
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;

    &::after {
      content: '';
      height: 11.51rem;
      width: 100%;
      position: absolute;
      background-image: url("../../assets/pc/donation/bgShadow.png");
      background-size: 100%;
      background-repeat: no-repeat;
      z-index: -79;
      top: 0.5rem;
    }

    .title {
      font-size: 0.4rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      color: #333333;
      line-height: 0.37rem;
      margin-top: 1.5rem;
      text-align: center;
      width: 100%;
      //margin-top: 1.87rem;
    }
    .label-p {
      font-size: 0.26rem;
      color: #333333;
      line-height: 0.36rem;
      label {
        font-family: PingFangSC, PingFangSC-Regular;
        color: #333333;
      }
    }

    .address-container {
      margin-top: 0.37rem;
      width: 4.9rem;

      .address {
        box-sizing: content-box;
        margin-left: -0.02rem;
        width: 4.5rem;
        height: 0.63rem;
        background: rgba(255,255,255,0.20);
        border: 0.02rem solid #ffffff;
        border-radius: 0.04rem;
        margin-top: 0.11rem;
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        padding: 0 0.2rem;
      }
      .donate-count {
        display: block;
        color: #333333;
        padding: 0 0.2rem;
        font-size: 0.24rem;
      }
    }
    .donate-chain-container {
      margin-top: 0.37rem;
      width: 4.9rem;
      cursor: pointer;

      .donate-chain {
        box-sizing: content-box;
        margin-left: -0.02rem;
        width: 4.9rem;
        height: 0.63rem;
        background: rgba(255,255,255,0.20);
        border: 0.02rem solid #ffffff;
        border-radius: 0.04rem;
        margin-top: 0.11rem;
        display: flex;
        align-items: center;

        .chain-container {
          width: 0.4rem;
          height: 0.4rem;
          margin-left: -0.11rem;

          &:first-child {
            margin-left: 0.23rem;
          }
        }
        .chain-title {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #3a3b3d;
          margin-left: 0.1rem;
        }

        .right-container {
          width: 0.1rem;
          height: 0.2rem;
          background-image: url("../../assets/pc/donation/right.png");
          margin-right: 0.24rem;
          margin-left: auto;
        }
      }
      .donate-chain-slide {
        position: absolute;
        width: 4.9rem;
        margin-top: 0.1rem;

        ul {
          background-color: white;
          border-radius: 0.04rem;
          li {
            height: 0.6rem;
            width: 4.44rem;
            margin: 0 auto;
            border-bottom: #e8eaec 0.01rem solid;
            display: flex;
            align-items: center;

            img {
              height: 0.4rem;
              width: 0.4rem;
            }
            span {
              font-size: 0.24rem;
              margin-left: 0.1rem;
              font-family: PingFangSC, PingFangSC-Regular;
              color: #3a3b3d;

              &.chosen-chain {
                color: #2761e7;
              }
            }
          }
        }
      }
    }
    .tip-container {
      margin-top: 0.3rem;
      p {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #ed4c56;
        line-height: 0.3rem;
        width: 4.54rem;
      }
    }
    .button-container {
      margin-top: 0.24rem;
      width: 4.32rem;
      height: 1rem;
      font-size: 0.22rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #ffffff;

      &.normal {
        background-image: url("../../assets/pc/button.png");
      }
      &.down {
        background-image: url("../../assets/pc/button_down.png");
        transform: translate(0.03rem, 0.03rem);
      }
    }
    .disabled-button-container {
      margin-top: 0.34rem;
      width: 4.32rem;
      height: 0.8rem;
      border-radius: 0.4rem;
      font-size: 0.22rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #ffffff;
      background-color: #93bffe;
      text-align: center;
    }
  }
}
</style>
